import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* istanbul ignore file */

import { PxCaptchaTypes, View } from "../store/types";
import { setGenericError, setLoading, setPxCaptchaType } from "../store/sharedActions";
import { EventTypes, recordEvents } from "./newRelicEvents";
import { PxError } from '@chegg/one-auth-sdk';
import config from "../config";
import { getTexts } from "../lib/contentful/defaultTexts";
import { getCookieDomain } from '@chegg/one-auth-sdk';
import { rewriteCheggTldToMatch } from '@chegg/utils';
export function handlePxResponse(response, onValidateFunction, env) {
  var cookieDomain = getCookieDomain();
  window._pxOnCaptchaSuccess = onValidateFunction;
  setTimeout(function () {
    var _rewriteCheggTldToMat;
    if (document.querySelector('#px-captcha-modal')) {
      console.log('auto abr enabled');
      return;
    }
    console.log('px auto abr is disabled, fallback to inline captcha');
    // set the origin of the block script (different between auth-gate and jericho requests)
    var origin = (_rewriteCheggTldToMat = rewriteCheggTldToMatch(!response.apiName || response.apiName === 'initSession' ? config[env].pxCheggClientOrigin : config[env].pxAuthGateClientOrigin, cookieDomain)) !== null && _rewriteCheggTldToMat !== void 0 ? _rewriteCheggTldToMat : 'config[env].pxAuthGateClientOrigin';
    injectPerimeterXWindowProperties(_objectSpread({}, response), origin);
    if (document.querySelector('[data-test="px_captcha_snippet"]')) {
      // in case we get different blockScripts from auth-gate or jericho
      try {
        document.head.removeChild(document.querySelector('[data-test="px_captcha_snippet"]'));
      } catch (error) {
        console.error('could not remove px script child', error);
      }
    }
    // new script element which is used to load the PerimeterX challenge script
    var script = document.createElement('script');
    script.setAttribute('data-test', 'px_captcha_snippet');
    script.src = "".concat(origin).concat(response.blockScript);
    document.getElementsByTagName('head')[0].appendChild(script);
  }, 2000);
}
export function initiatePx(env, error, dispatch, clientId, pxCaptchaType, authType, isJericho, cb) {
  //@ts-ignore
  dispatch(setPxCaptchaType({
    type: pxCaptchaType
  }));
  var pxValidation = function pxValidation(isValid, pxUuid) {
    if (isValid) {
      var onView = View.SIGNIN;
      switch (pxCaptchaType) {
        case PxCaptchaTypes.LOGIN:
          onView = View.SIGNIN;
          break;
        case PxCaptchaTypes.SIGNUP:
          onView = View.SIGNUP;
          break;
        case PxCaptchaTypes.RESET_PASSWORD:
          onView = View.RESET_PASSWORD;
          break;
      }
      dispatch(setGenericError({
        error: ''
      }));
      dispatch(setPxCaptchaType({
        type: undefined
      }));
      dispatch(setLoading({
        loading: false,
        onView: onView
      }));
      if (cb) {
        cb();
      }
      recordEvents(_defineProperty({}, EventTypes.pxCaptchaSuccess, {
        type: pxCaptchaType,
        pxUuid: pxUuid,
        clientId: clientId,
        authType: authType,
        apiName: error instanceof PxError && error.apiName || ''
      }));
    } else {
      dispatch(setGenericError({
        error: getTexts().signup.pxValidationError
      }));
      recordEvents(_defineProperty({}, EventTypes.pxCaptchaFailed, {
        type: pxCaptchaType,
        pxUuid: pxUuid,
        clientId: clientId,
        authType: authType,
        apiName: error instanceof PxError && error.apiName || ''
      }));
    }
  };
  try {
    var pxResponse = isJericho ? JSON.parse(error.message) : JSON.parse(JSON.stringify(error));
    handlePxResponse(pxResponse, function (isValid) {
      return pxValidation(isValid, pxResponse.uuid);
    }, env);
    recordEvents(_defineProperty({}, EventTypes.pxCaptchaDisplayed, {
      type: pxCaptchaType,
      pxUuid: pxResponse === null || pxResponse === void 0 ? void 0 : pxResponse.uuid,
      clientId: clientId,
      authType: authType,
      apiName: error.apiName || ''
    }));
  } catch (e) {
    //
  }
}
function injectPerimeterXWindowProperties(props, origin) {
  // Mandatory window properties
  window._pxAppId = "".concat(props.appId); // PerimeterX's application id
  window._pxJsClientSrc = "".concat(origin).concat(props.jsClientSrc); // PerimeterX's JavaScript sensor url
  window._pxFirstPartyEnabled = props.firstPartyEnabled; // A boolean flag indicating wether first party is enabled or not
  window._pxVid = "".concat(props.vid); // PerimeterX's visitor id
  window._pxUuid = "".concat(props.uuid); // PerimeterX's unique user id
  window._pxHostUrl = "".concat(props.hostUrl); // PerimeterX's cloud component URL
}